<template>
  <div>
    <TasksTable
      :fixedPagination="true"
      :showProjectColumn="true"
      :taskStatus="$route.params.status"
      class="content-block"
      :queryFilter="queryFilter"
      :querySorter="querySorter"
      :queryPager="queryPager"
      :addButton="{ name: 'tasksNew'}"
      @filter-changed="onFilterChanged"
      @sorter-changed="onSorterChanged"
      @pager-changed="onPageChanged"
    ></TasksTable>
  </div>
</template>

<script>
import TasksTable from 'CORE/components/task/table'
import PersistentQueryMixin from 'CORE/mixins/persistent-query'

export default {
    name: 'Tasks',
    components: {
        TasksTable,
    },
    mixins: [
        PersistentQueryMixin,
    ],
}
</script>
